import { HttpError } from 'src/toolkit';

import { TFormFieldValidation } from './validation';

type TErrors = string[];

type TField = {
	name: string;
	errors: TErrors;
	setErrors: (value: TErrors) => void;
};

type TFormMapFieldsNum = {
	[name: string]: TField;
};

export function formHandleServerError(error: HttpError, setNotice: (value: string) => void, ...fields: TField[]) {
	const { data, text } = error;

	if (!data) {
		if (text) {
			setNotice(text);
		}

		return;
	}

	const { validation = [], message } = data;

	if (validation.length > 0) {
		return formMapErrors(validation, ...fields);
	}

	const str = message || text;

	if (str) {
		setNotice(str);
	}
}

export function formMapErrors(errors: TFormFieldValidation[], ...fields: TField[]) {
	const fieldsNum: TFormMapFieldsNum = {};

	fields.forEach(item => fieldsNum[item.name] = item);

	errors.forEach(item => {
		const { message, field_name: fieldName } = item;

		const field = fieldsNum[fieldName];

		if (field) {
			field.setErrors([message]);
		}
	});
}

export function formMapError(errors: TFormFieldValidation[], field: TField) {
	errors.forEach(item => {
		const { message } = item;

		if (field) {
			field.setErrors([message]);
		}
	});
}
